// extracted by css-extract-rspack-plugin
export default {"searchTextBox":"SearchTextBox__searchTextBox--v55VZ","searchTextBoxError":"SearchTextBox__searchTextBoxError--XQPaf"};